<div class="custom-box d-flex justify-content-center" [ngClass]="{'red-bg': class === 0, 'yellow-bg': class === 1, 'green-bg': class === 2}">
  <div class="text-center">
    <p class="message m-0 mt-2">{{message}}</p>
    <p class="number2 m-0" style="margin-top: -10px!important">{{number}}%</p>
  </div>
</div>
